import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button } from "@mui/material";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import TopTitleFormComponent from "./TopTitleFormComponent";
import ReactToPrint from "react-to-print";

function ViewSelfoutingPrivileges(props) {
  // const { clientId, closemodal, firstName, lastName } = props;
  const { clientId, privilegeId, closemodal, firstName, lastName } = props;
  const [purpose, setPurpose] = useState("");
  const [responsibilities, setResponsibilities] = useState("");
  const [consequences, setConsequences] = useState("");
  const [acknowledgment, setAcknowledgment] = useState("");
  const [signaturePic, setSignaturePic] = useState(null);
  const [signedOn, setSignedOn] = useState(null);
  const printRef = useRef();
  const [outingDate, setOutingDate] = useState(null);
  const [timeframe, setTimeframe] = useState("");
  const [goingWith, setGoingWith] = useState("");
  const [destination, setDestination] = useState("");
  const [outingPurpose, setOutingPurpose] = useState("");

  const fetchData = useCallback(async () => {
    try {
      const docRef = doc(
        db,
        "clients",
        clientId,
        "ConsentSelfOutingPrivileges",
        privilegeId
      );
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setPurpose(data.purpose || "");
        setResponsibilities(data.responsibilities || "");
        setConsequences(data.consequences || "");
        setAcknowledgment(data.acknowledgment || "");
        setSignedOn(data.signedOn || null);
        setOutingDate(data.outingDate || null);
        setTimeframe(data.timeframe || "");
        setGoingWith(data.goingWith || "");
        setDestination(data.destination || "");
        setOutingPurpose(data.outingPurpose || "");

        if (data.signatureURL) {
          setSignaturePic(data.signatureURL);
        }
      } else {
        console.log("No such document (ConsentSelfOutingPrivilege)!");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [clientId, privilegeId]);

  console.log("privilegeID in ViewSelfOutingPrivilege:", privilegeId);

  useEffect(() => {
    if (!privilegeId) return;
    fetchData();
  }, [fetchData, privilegeId]);
  function formatDate(timestamp) {
    if (!timestamp || !timestamp.toDate) return "";
    const date = timestamp.toDate();
    const day = date.getDate().toString().padStart(2, "0");
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const timeZone = date
      .toLocaleString("en", { timeZoneName: "short" })
      .split(" ")
      .pop();
    return `${day} ${month} ${year} ${hours}:${minutes} ${timeZone}`;
  }

  return (
    <>
      <style>
        {`
          @media print {
            #printableContent {
              height: auto !important;
              overflow-y: visible !important;
            }
          }
        `}
      </style>
      <div style={{ width: "auto", height: "100%" }}>
        <div className="line1-modal-percent">
          <TopTitleFormComponent
            title="Consent and Self-Outing Privilege Form"
            closemodal={closemodal}
          />
        </div>
        <div
          id="printableContent"
          style={{
            width: "100%",
            marginTop: "10px",
            height: "80%",
            overflowY: "scroll",
            paddingLeft: "30px",
          }}
          ref={printRef}
        >
          <div
            className="client-name-container"
            style={{ marginBottom: "10px" }}
          >
            Consent and Self-Outing Privilege Form for: {firstName} {lastName}
          </div>
          {signedOn && <p>Signed on: {formatDate(signedOn)}</p>}
          <div
            className="text-block"
            style={{ whiteSpace: "pre-line", marginTop: "10px" }}
            dangerouslySetInnerHTML={{
              __html: `${purpose}`,
            }}
          />
          <div
            className="text-block"
            style={{ whiteSpace: "pre-line", marginTop: "10px" }}
            dangerouslySetInnerHTML={{
              __html: `${responsibilities}`,
            }}
          />
          <div
            className="text-block"
            style={{ whiteSpace: "pre-line", marginTop: "10px" }}
            dangerouslySetInnerHTML={{
              __html: `${consequences}`,
            }}
          />
          <div
            className="text-block"
            style={{ whiteSpace: "pre-line", marginTop: "10px" }}
            dangerouslySetInnerHTML={{
              __html: `${acknowledgment}`,
            }}
          />

          <div
            style={{
              paddingLeft: "20px",
              paddingTop: "20px",
              marginBottom: "10px",
            }}
          >
            {outingDate && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "10px",
                  gap: "10px",
                }}
              >
                <div style={{ fontWeight: "600" }}>Date of Outing:</div>{" "}
                {formatDate(outingDate)}
              </div>
            )}
            {timeframe && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "10px",
                  gap: "10px",
                }}
              >
                <div style={{ fontWeight: "600" }}>Timeframe:</div> {timeframe}
              </div>
            )}
            {goingWith && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "10px",
                  gap: "10px",
                }}
              >
                <div style={{ fontWeight: "600" }}>
                  Who they are going with:
                </div>{" "}
                {goingWith}
              </div>
            )}
            {destination && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "10px",
                  gap: "10px",
                }}
              >
                <div style={{ fontWeight: "600" }}>Destination:</div>{" "}
                {destination}
              </div>
            )}
            {outingPurpose && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "10px",
                  gap: "10px",
                }}
              >
                <div style={{ fontWeight: "600" }}>Purpose:</div>{" "}
                {outingPurpose}
              </div>
            )}
          </div>

          <div
            className="text-block"
            style={{ marginTop: "20px", fontStyle: "italic" }}
          >
            I fully understand and agree to the above terms.
          </div>

          <div
            className="signature-date-container"
            style={{
              marginTop: "15px",
              paddingLeft: "20px",
              marginBottom: "20px",
            }}
          >
            {signaturePic && (
              <div>
                <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
                  Client Signature:
                </div>
                <img
                  alt="Client Signature"
                  src={signaturePic}
                  style={{ border: "1px solid #ccc", width: "200px" }}
                />
              </div>
            )}
          </div>
        </div>
        <div className="line4-modal-percent-bis">
          <>
            <Button
              variant="contained"
              style={{ backgroundColor: "white", color: "black" }}
              onClick={closemodal}
            >
              Cancel
            </Button>
            <ReactToPrint
              trigger={() => (
                <Button variant="contained" style={{ marginLeft: "20px" }}>
                  Print
                </Button>
              )}
              content={() => printRef.current}
              onAfterPrint={closemodal}
            />
          </>
        </div>
      </div>
    </>
  );
}

export default ViewSelfoutingPrivileges;
